import { http } from '../../config/axios'

export default function postUser(user: any): Promise<string> {
  return http
    .post('api/user', user)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post user', error)
      throw Error(error.response.data)
    })
}
